import React from 'react';
import { styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { Intl } from '@atlassian/jira-shared-types/src/general.tsx';
import type { WorkingTime } from '../../../../common/types';
import { Row, DayColumn, Column, Grid } from '../../../../common/ui/styled';
import messages from './messages';

type Props = {
	day: string;
	defaultWorkingTimes?: WorkingTime[];
} & Intl;

export const DayWithHoursView = ({ intl: { formatMessage }, day, defaultWorkingTimes }: Props) => {
	if (!defaultWorkingTimes) {
		return null;
	}
	return (
		<WorkingTimesGrid>
			<Row>
				{/* @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type '`${string}Description`' can't be used to index type '{ parallelSprintsDescription: MessageDescriptorV2; parallelSprintsTitle: MessageDescriptorV2; }'. */}
				<DayColumn>{formatMessage(messages[day])}</DayColumn>
				<Column>
					{defaultWorkingTimes.map(({ start, end }) => (
						<Grid
							key={`${day}${start}${end}`}
							data-test-id={`servicedesk-sla-settings.ui.calendars.calendar.work-week.grid-${day}`}
						>
							{start} {formatMessage(messages.to)} {end}
						</Grid>
					))}
				</Column>
			</Row>
		</WorkingTimesGrid>
	);
};

export const DayWithHours = injectIntl(DayWithHoursView);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const WorkingTimesGrid = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text', colors.DN0),
	marginTop: token('space.100', '8px'),
});
